module.exports = __webpack_public_path__ + "static/media/commander.c03c60a7.jpg";